import { useEffect, useState } from 'react';
import { getDirection } from '../helpers';

const swipeThreshold = 50;
const useOnSwipe = ({
  eventData,
  currentItemIndex,
  childrenLength,
  onSwipeComplete,
  onLeftSwipe,
  onRightSwipe
}) => {
  const [currentItem, setCurrentItem] = useState(currentItemIndex);

  useEffect(() => {
    const deltaX = eventData.startClientX - eventData.endClientX;
    const absX = Math.abs(deltaX);
    const direction = getDirection(absX, 0, deltaX, 0);
    const hasMetThreshold = absX > swipeThreshold;

    if (!eventData.isSwiping && direction) {
      if (onSwipeComplete) onSwipeComplete({ direction });

      if (hasMetThreshold) {
        const nextItem =
          direction === 'left' ? currentItem + 1 : currentItem - 1;
        const hasMetUpperLimit = nextItem >= childrenLength;
        const hasMetLowerLimit = nextItem < 0;

        if (onLeftSwipe && direction === 'left') onLeftSwipe();
        if (onRightSwipe && direction === 'right') onRightSwipe();

        if (!hasMetLowerLimit && !hasMetUpperLimit)
          setCurrentItem(
            direction === 'left' ? currentItem + 1 : currentItem - 1
          );
      }
    } else {
      setCurrentItem(currentItem);
    }
  }, [eventData.isSwiping]);

  return [currentItem, setCurrentItem];
};

export default useOnSwipe;
